import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { InsightsState } from 'app-redux/InsightsState';
import { nameof } from 'utils/typeHelpers';

export type DiseaseActivitiesTimeFrameState = {
  startDate: string;
};

export const InitialDiseaseActivitiesTimeFrameState: DiseaseActivitiesTimeFrameState = {
  startDate: null,
};

const diseaseActivitiesTimeFrameSlice = createSlice({
  name: nameof<InsightsState>('diseaseActivitiesTimeFrame'),
  initialState: InitialDiseaseActivitiesTimeFrameState,
  reducers: {
    changeStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
  },
});

const { actions, reducer } = diseaseActivitiesTimeFrameSlice;
export const { changeStartDate } = actions;
export default reducer;
